import { render, staticRenderFns } from "./SparepartsTable.vue?vue&type=template&id=b439f140&scoped=true"
import script from "./SparepartsTable.vue?vue&type=script&lang=js"
export * from "./SparepartsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b439f140",
  null
  
)

export default component.exports